// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".svg-icon[data-v-1c33b0e2]{width:auto;height:auto;display:inline}.svg-icon svg[data-v-1c33b0e2]{pointer-events:none;width:1.5rem;height:1.5rem}", ""]);
// Exports
module.exports = exports;
